<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-text-field v-model="query.studentNo" label="学号" dense outlined></v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field v-model="query.studentName" label="姓名" dense outlined></v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="状态" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn small @click="showAdd" color="info">给学员发放优惠券</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					
					<span v-if="item.status=='1'" style="color:#FF9100">未使用</span>
					<span v-if="item.status=='2'">已使用</span>
					<span v-if="item.status=='0'" style="color:red">作废</span>
				</template>
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="frozenStudentCoupon(item)" :disabled="item.status !== '1'" color="info" small>作废</v-btn>
					<v-btn @click.stop="freeStudentCoupon(item)" :disabled="item.status !== '0'" color="info" class="ml-3" small>启用</v-btn>
				</template>
				
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 添加dialog -->
		<v-dialog title="发放优惠券" v-model="add.dialog" max-width="600">
			<v-card>
				<v-card-title>发放优惠券</v-card-title>
				<v-card-text>
					<v-row dense>
					
						<v-col cols="12">
							<v-autocomplete :items="selectStudentList" v-model="add.form.studentId"
							        item-text="studentName" item-value="id"
							        label="学员"  dense outlined></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-select :items="selectCouponList" v-model="add.form.couponId"
							item-text="caption" item-value="id" label="优惠券" dense outlined no-data-text="该校区暂无可用优惠券"></v-select>
								
						</v-col>
						
						<v-col cols="12">
							<v-text-field label="备注" v-model="add.form.memo" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "student-cash-list",
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员优惠券',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '优惠券名称',
							value: 'couponName',
							sortable: false
						},
						{
							text: '优惠券金额',
							value: 'amount',
							sortable: false
						},
						
						{
							text: '满多少金额可用',
							value: 'limitAmount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '过期时间',
							value: 'expireDate',
							sortable: false
						},
						{
							text: '发放时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectStudentList: [], //选择学生数据源
				selectCouponList: [], //选择优惠券数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "未使用"
					},
					{
						id: "2",
						statusName: "已使用"
					},
					{
						id: "0",
						statusName: "作废"
					},
				],

				query: {
					loading: false,
					page: 1,
					size: 20,
					studentNo: "",
					studentName: "",
					status: ""
				},
				add:{
					dialog:false,
					form:{
						shopId:"",
						studentId:"",
						couponId:"",
						memo:"",
					}
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId()
			this.getTableDataList();
		},
		onLoad(options = {}){
			console.log("onload");
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAdd(){
				if(this.selectCouponList.length==0){
					this.getCouponsForSelect();
				}
				
				if (this.selectStudentList.length == 0){
					this.getStudentsForSelect();
				}

				this.add.form.studentId = "";
				this.add.form.couponId = "";
				this.add.form.memo = "";
				
				this.add.dialog = true;
			},
			submitAdd(){
				
				if(!this.add.form.studentId){
					this.$noty.error("请选择学员");
					return
				}
				if(!this.add.form.couponId){
					this.$noty.error("请选择优惠券");
					return
				}
				// api
				const that = this;
				let url = `/financial/student/coupon/create`;
				let postData = {...this.add.form};
				postData.shopId = this.shopId;

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			frozenStudentCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/student/coupon/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeStudentCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/student/coupon/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/financial/student/coupon/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;


				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
			
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "未使用";
				} else if (state === "0") {
					stName = "作废";
				}else if (state === "2") {
					stName = "已使用";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "primary";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}

				return color;
			},
			
		
			getStudentsForSelect(){
				
				const that = this;
				let url = `/edu/shop/student/list/${this.shopId}`;
			
				this.axios.get(url).then(response => {
					
					console.log(response.data["data"]);
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCouponsForSelect(){
				const that = this;
				let url = `/financial/shop/coupon/list/${this.shopId}`;
				
				
			
				this.axios.get(url).then(response => {
		
					console.log("get coupon",response.data["data"]);
					if (response.data["code"] === 200) {
						that.selectCouponList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		
		}
	}
</script>

<style>
</style>
